<template>
	<RunningProgramsAdmin kind="gym" />
</template>

<script>
import RunningProgramsAdmin from './RunningProgramsAdmin.vue'

export default {
	name: 'GestioneSchedePalestraAdmin',
	components: { RunningProgramsAdmin }
}
</script>
